import { render, staticRenderFns } from "./snapShot.vue?vue&type=template&id=21e72a3e&scoped=true"
import script from "./snapShot.vue?vue&type=script&lang=js"
export * from "./snapShot.vue?vue&type=script&lang=js"
import style0 from "./snapShot.vue?vue&type=style&index=0&id=21e72a3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e72a3e",
  null
  
)

export default component.exports